/**
 * @typedef {Object} LeaderCard
 * @property {string} card.front
 * @property {string} card.back
 */

/**
 * @typedef {Object} Leader
 * @property {string} id
 * @property {string} name
 * @property {string} subTitle
 * @property {Array<string>} aspect
 * @property {LeaderCard} card
 *
 */

/**
 * @type {Array<Leader>}
 */
export const leaders = [
  {
    id: "SOR001",
    name: "Director Krennic",
    subTitle: "Aspiring to Authority",
    aspect: ["vigilance", "villain"],
    card: {
      front: "SWH_01_001_Director_Krennic_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR002",
    name: "Iden Versio",
    subTitle: "Inferno Squad Commander",
    aspect: ["vigilance", "villain"],
    card: {
      front: "SWH_01_002_Iden_Versio_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR003",
    name: "Chewbacca",
    subTitle: "Walking Carpet",
    aspect: ["vigilance", "heroism"],
    card: {
      front: "SWH_01_003_Chewbacca_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR004",
    name: "Chirrut Îmwe",
    subTitle: "One with the Force",
    aspect: ["vigilance", "heroism"],
    card: {
      front: "SWH_01_004_Chirrut_Îmwe_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR005",
    name: "Luke Skywalker",
    subTitle: "Faithful friend",
    aspect: ["vigilance", "heroism"],
    card: {
      front: "SWH_01_005_Luke_Skywalker_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SHD001",
    name: "Gar Saxon",
    subTitle: "Viceroy of Mandalore",
    aspect: ["vigilance", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD002",
    name: "Qi’ra",
    subTitle: "I Alone Survived",
    aspect: ["vigilance", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD003",
    name: "Finn",
    subTitle: "This is a Rescue",
    aspect: ["vigilance", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD004",
    name: "Rey",
    subTitle: "More Than a Scavenger",
    aspect: ["vigilance", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SOR006",
    name: "Emperor Palpatine",
    subTitle: "Galactic Ruler",
    aspect: ["command", "villain"],
    card: {
      front: "SWH_01_006_Emperor_Palpatine_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR007",
    name: "Grand Moff Tarkin",
    subTitle: "Oversector Governor",
    aspect: ["command", "villain"],
    card: {
      front: "SWH_01_007_Grand_Moff_Tarkin_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR008",
    name: "Hera Syndulla",
    subTitle: "Spectre two",
    aspect: ["command", "heroism"],
    card: {
      front: "SWH_01_008_Hera_Syndulla_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR009",
    name: "Leia Organa",
    subTitle: "Alliance general",
    aspect: ["command", "heroism"],
    card: {
      front: "SWH_01_009_Leia_Organa_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SHD005",
    name: "Hondo Ohnaka",
    subTitle: "That’s Good Business",
    aspect: ["command", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD006",
    name: "Jabba the Hutt",
    subTitle: "His High Exaltedness",
    aspect: ["command", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },

  {
    id: "SHD007",
    name: "Moff Gideon",
    subTitle: "Formidable Commander",
    aspect: ["command", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD008",
    name: "Boba Fett",
    subTitle: "Daimyo",
    aspect: ["command", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD009",
    name: "Hunter",
    subTitle: "Outcast Sergeant",
    aspect: ["command", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SOR010",
    name: "Darth Vader",
    subTitle: "Dark Lord of the Sith",
    aspect: ["aggression", "villain"],
    card: {
      front: "SWH_01_010_Darth_Vader_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR011",
    name: "Grand Inquisitor",
    subTitle: "Hunting the Jedi",
    aspect: ["aggression", "villain"],
    card: {
      front: "SWH_01_011_Grand_Inquisitor_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR012",
    name: "IG-88",
    subTitle: "Ruthless Bounty Hunter",
    aspect: ["aggression", "villain"],
    card: {
      front: "SWH_01_012_IG-88_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR013",
    name: "Cassian Andor",
    subTitle: "Dedicated to the rebellion",
    aspect: ["aggression", "heroism"],
    card: {
      front: "SWH_01_013_Cassian_Andor_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR014",
    name: "Sabine Wren",
    subTitle: "Galvanized Revolutionary",
    aspect: ["aggression", "heroism"],
    card: {
      front: "SWH_01_014_Sabine_Wren_Front_HYP.webp",
      back: undefined,
    },
  },

  {
    id: "SHD010",
    name: "Bossk",
    subTitle: "Hunting His Prey",
    aspect: ["aggression", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD011",
    name: "Kylo Ren",
    subTitle: "Rash and Deadly",
    aspect: ["aggression", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD012",
    name: "Bo-Katan Kryze",
    subTitle: "Princess in Exile",
    aspect: ["aggression", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD013",
    name: "Han Solo",
    subTitle: "Worth the Risk",
    aspect: ["aggression", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SOR015",
    name: "Bobba Fett",
    subTitle: "Collecting the Bounty",
    aspect: ["cunning", "villain"],
    card: {
      front: "SWH_01_015_Bobba_Fett_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR016",
    name: "Grand Admiral Thrawn",
    subTitle: "Patient and Insightful",
    aspect: ["cunning", "villain"],
    card: {
      front: "SWH_01_016_Grand_Admiral_Thrawn_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR017",
    name: "Han Solo",
    subTitle: "Audacious Smuggler",
    aspect: ["cunning", "heroism"],
    card: {
      front: "SWH_01_017_Han_Solo_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SOR018",
    name: "Jyn Erso",
    subTitle: "Resisting Opression",
    aspect: ["cunning", "heroism"],
    card: {
      front: "SWH_01_018_Jyn_Erso_Front_HYP.webp",
      back: undefined,
    },
  },
  {
    id: "SHD014",
    name: "Cad Bane",
    subTitle: "He Who Needs No Introduction",
    aspect: ["cunning", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD015",
    name: "Doctor Aphra",
    subTitle: "Rapacious Archaeologist",
    aspect: ["cunning", "villain"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD016",
    name: "Fennec Shand",
    subTitle: "Honoring the Deal",
    aspect: ["cunning", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD017",
    name: "Lando Calrissian",
    subTitle: "With Impeccable Taste",
    aspect: ["cunning", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
  {
    id: "SHD018",
    name: "The Mandalorian",
    subTitle: "Sworn To The Creed",
    aspect: ["cunning", "heroism"],
    card: {
      front: "",
      back: undefined,
    },
  },
];
